import createArrayFromNumber from '@/utilities/createArrayFromNumber';

export default function getRandomNumberArray(
  length: number,
  min: number,
  max: number,
  shouldGenerateUniqueNumbers: boolean = false,
  numbersToExclude: number[] = []
): number[] {
  return createArrayFromNumber(length).reduce((result: number[]): number[] => {
    let newNumber: number;
    do {
      newNumber = generateRandomNumber(min, max);
    } while (
      shouldGenerateUniqueNumbers &&
      (result.indexOf(newNumber) >= 0 ||
        numbersToExclude.indexOf(newNumber) >= 0)
    );
    result.push(newNumber);
    return result;
  }, []);
}

function generateRandomNumber(min: number, max: number): number {
  let randomNumber = Math.random();
  if (window?.crypto?.getRandomValues) {
    const buffer = new Uint32Array(1);
    window?.crypto.getRandomValues(buffer);
    randomNumber = buffer[0] / (0xffffffff + 1);
  }
  return Math.floor(randomNumber * (max - min + 1)) + min;
}
